// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENT_SCA_TOKEN_REQUEST_POST = 'PAYMENT_SCA_TOKEN_REQUEST_POST';
export const PAYMENT_SCA_TOKEN_REQUEST_POST_SUCCESS = 'PAYMENT_SCA_TOKEN_REQUEST_POST_SUCCESS';
export const PAYMENT_SCA_TOKEN_REQUEST_POST_FAILURE = 'PAYMENT_SCA_TOKEN_REQUEST_POST_FAILURE';
export const PAYMENT_SETUP_COMPLETE = 'PAYMENT_SETUP_COMPLETE';
